/**
 * SeoBreadcrumb Functional Component
 * @Package - seo
 * @Author - Cybage@UPWA-Team
 * @description: Common SEO Breadcrumb
 */
/**
 *   SEO's Breadcrumb Component
 */
import React, { useContext } from 'react'
import { BreadcrumbWidget as CPBreadcrumb } from '@usap/widgets'
import { LocalContext } from '../../helpers/useLocalContext'

export default function SeoBreadcrumb({
  id, data, useLastLinkFlag,
}) {
  const { localContext } = useContext(LocalContext)
  const { Link } = localContext

  return (
    <CPBreadcrumb
      id={id}
      links={data}
      Link={Link}
      useLastLinkFlag={useLastLinkFlag}
    />
  )
}
